import React, { createContext, useContext, useEffect, useState } from 'react';
import { getDatabase, ref, onValue, set, remove } from 'firebase/database';
import { getAuth } from 'firebase/auth';

const NotificationsContext = createContext();

export const useNotifications = () => {
  return useContext(NotificationsContext);
};

export const NotificationsProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const auth = getAuth();

  useEffect(() => {
    const db = getDatabase();
  
    const fetchNotifications = (user) => {
      if (!user) return setNotifications([]); // Ensure no notifications for unauthenticated users
  
      const notificationsRef = ref(db, `users/${user.uid}/notifications`);
  
      return onValue(notificationsRef, (snapshot) => {
        const data = snapshot.val();
        setNotifications(data ? Object.keys(data).map((key) => ({ id: key, ...data[key] })) : []);
      });
    };
  
    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      setNotifications([]); // Reset notifications when switching users
      if (user) {
        return fetchNotifications(user);
      }
    });
  
    return () => unsubscribeAuth();
  }, []);
  
  
  const markAsRead = (id) => {
    const user = auth.currentUser;
    if (user) {
      const db = getDatabase();
      const notificationRef = ref(db, `users/${user.uid}/notifications/${id}/read`);
      set(notificationRef, true);  // Mark notification as read
    }
  };

  const deleteNotification = (id) => {
    const user = auth.currentUser;
    if (user) {
      const db = getDatabase();
      const notificationRef = ref(db, `users/${user.uid}/notifications/${id}`);
      remove(notificationRef);  // Delete notification
    }
  };

  return (
    <NotificationsContext.Provider value={{ notifications, markAsRead, deleteNotification }}>
      {children}
    </NotificationsContext.Provider>
  );
};